import { useNotification } from './hooks/notifications';
import Servers from './servers';
import Storages from './storages';
import Cdroms from './cdroms';
import Lans from './lans';
import Layout from './layout';
import Form from './form';
import NICs from './nics';
import Cards from './cards-layout';
import Card from './card';
import Confirm from './confirm-dialog';
import ConfirmPassword from './confirm-password';
import PropertiesDialog from './properties-dialog';
import Dialog from './dialog';
import Icon from './icon';
import Text from './form/input-field';
import Password from './form/password-field';
import Loader from './loader';
import Popover from './popover';
import Progress from './progress-bar';
import Properties from './properties-table';
import Range from './form/range-slider';
import Result from './result-dialog';
import Dropdown from './form/select-field';
import Snackbar from './snackbar';
import Switch from './form/switch';
import Tabs from './tabs';
import CardBasic from './card-basic';
import NotFound from './not-found';
import BootableDevices from './bootable-device';
import Loadbalancers from './load-balancers';
import utilities from './utilities';
import TableView from './table-view';
import IconPopup from './icon-popup';
import Tiles from './tiles';
import OverallServers from './overall-servers';
import NATGateway from './nat-gateway';
import Strap from './strap';
import AdServer from './ad-server';
import Page from './page';
import Section from './section';
import PopupMenu from './popup-menu';
import DBaaSPriceEstimation from './billing/dbaas-estimated-price';

export default {
  hooks: {
    useNotification,
  },

  components: {
    Servers,
    Storages,
    BootableDevices,
    Cdroms,
    Lans,
    NICs,
    NotFound,
    Loadbalancers,
    OverallServers,
    NATGateway,
    AdServer,
  },

  widgets: {
    Cards,
    Card,
    CardBasic,
    Icon,
    Loader,
    Popover,
    IconPopup,
    PopupMenu,
    Progress,
    Properties,
    Snackbar,
    Tabs,
    TableView,
    Tiles,
    Strap,
    Page,
    Section,
  },

  dialog: {
    Confirm,
    Dialog,
    Result,
    PropertiesDialog,
    ConfirmPassword,
  },

  Layout,

  utilities,

  forms: {
    Form,
    Text,
    Range,
    Dropdown,
    Switch,
    Password,
  },

  billing: {
    DBaaSPriceEstimation,
  },
};
